import "./resourceList.css";
import { useEffect, useState } from "react";

const ResourceList = (props) => {
  const [listArr, setListArr] = useState([]);
  useEffect(() => {
    const resourceList = props.data;
    createList(resourceList);
  }, [props.data]);

  const createList = (data) => {
    const newListArr = data?.map((list) => ({
      text: list.resourceType,
      count: list.objects.length,
    }));
    setListArr(newListArr);
  };

  return (
    <div className="listContainer">
      {listArr?.map((obj, idx) => (
        <div
          className={`${props.resource === obj.text ? "active" : ""} numberRow`}
          key={idx}
          onClick={() => props.setSelectedResource(obj.text)}
        >
          <p>{obj.text}</p>
          <p
            className={`${
              props.resource === obj.text ? " numberContainer_active" : ""
            } numberContainer`}
          >
            {obj.count}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ResourceList;
